module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon5.c823198f.png";